@if (orderScheduleList().length > 0) {
  <div class="row">
    <div class="col-6">
      <table id="data-table" class="table table-striped table-bordered w-100" aria-label="data-table">
        <thead>
          <tr>
            <th class="text-center w-25" scope="col">Warehouse</th>
            <th class="text-center w-30" scope="col">Schedule Type</th>
            <th class="text-center w-15" scope="col">Order Schedule</th>
            <th class="text-center w-15" scope="col">Pick Schedule</th>
            <th class="text-center w-15" scope="col">Delivery Schedule</th>
          </tr>
        </thead>
        <tbody>
          @for (orderSchedule of orderScheduleList(); track orderSchedule.warehouseName) {
            <tr>
              <td [rowSpan]="orderSchedule.rowSpan">{{ orderSchedule.warehouseName }}</td>
            </tr>
            @for (scheduleList of orderSchedule.scheduleList; track scheduleList) {
              <tr>
                <td [rowSpan]="scheduleList.rowSpan">
                  <ul>
                    @for (scheduleType of scheduleList.type; track scheduleType) {
                      <li>{{ scheduleType }}</li>
                    }
                  </ul>
                </td>
              </tr>
              @for (scheduleDay of scheduleList.scheduleDay; track scheduleDay) {
                <tr>
                  <td class="text-center">{{ scheduleDay.orderScheduleDate }}</td>
                  <td class="text-center">{{ scheduleDay.pickScheduleDate }}</td>
                  <td class="text-center">{{ scheduleDay.deliverySchedule }}</td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>
  </div>
} @else {
  <div class="no-result-container" [attr.data-id]="'noData'" id="noData">
    <div class="no-result-img">
      <img alt="Data not found" [ngSrc]="env.assetPath + '/no-order-schedule.svg'" height="164" width="164" />
      <div class="no-result-text-container">
        <span class="no-result-text">No Order Schedule</span>
      </div>
    </div>
  </div>
}
